import Utils from "../../../utils"

export const createChildAccountsApiCall = (values, setSubmitting, refetch) => {
  const dataToSend = values;
  return new Promise((resolve, reject) => {

    Utils.api.postApiCallForm(
      `${Utils.EndPoint.vendorEndpoints.createChildAccountsApi}`,
      dataToSend,
      (respData) => {
          const { data } = respData
          Utils.showAlert(1, 'Account created, Please check your email')
          setSubmitting(false);
          refetch();
          resolve(data);
      },
      (error) => {
          const { data } = error
          Utils.showAlert(2, data.error);
          setSubmitting(false);
          reject(error);
      }
    )
  });
}

export const updateChildAccountDetailApiCall = (values, accountId, setSubmitting, refetch) => {
  const dataToSend = values;
  Utils.api.patchApiCallForm(
    `${Utils.EndPoint.vendorEndpoints.childAccountsListApi}${accountId}/`,
    dataToSend,
    (respData) => {
      const { data } = respData
      Utils.showAlert(1, 'Location Updated');
      setSubmitting(false);
      refetch();
    },
    (error) => {
      
      const { data } = error
      Utils.showAlert(2, `Unable to update`)
      setSubmitting(false);
    }
  )
}

export const deleteChildAccountApiCall = (id, refetch) => {
  Utils.api.deleteApiCall(
    `${Utils.EndPoint.vendorEndpoints.deleteChildAccountApi}${id}/`,
    '',
    (respData) => {
      Utils.showAlert(1, 'Location Deleted');
      refetch();
    },
    (error) => {
      const { data } = error;
      Utils.showAlert(2, data.error || `Unable to delete location`)
    }
  )
}